'use client';

import React from 'react';
import { newCarsProject, newCarsTrack } from '~/constants/eventable';
import AnalyticsProvider from '~/context/common/AnalyticsProvider';
import {
  StaticContextProvider,
  type OwnProps as StaticContextProps
} from '~/context/common/StaticContext';
import {
  UserContextProvider,
  type OwnProps as UserContextProps
} from '~/context/common/UserContext';

type OwnProps = React.PropsWithChildren<{
  forStaticContext: StaticContextProps;
  forUserContext: UserContextProps;
}>;

export default function NewCarsLandingProviders({
  children,
  forStaticContext,
  forUserContext
}: OwnProps) {
  return (
    <StaticContextProvider {...forStaticContext}>
      <UserContextProvider {...forUserContext}>
        <AnalyticsProvider projectName={newCarsProject} track={newCarsTrack}>
          {children}
        </AnalyticsProvider>
      </UserContextProvider>
    </StaticContextProvider>
  );
}
